<div class="page-wrapper">

  <div class="page-header">
    <div class="page-title">
      <svg class="page-title__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.449 8.44818L16.3878 10.9992C16.5374 11.6574 16.5374 12.3426 16.3878 13.0008L19.449 15.5518C20.517 13.3118 20.517 10.6882 19.449 8.44818ZM15.5518 19.449L13.0008 16.3878C12.3426 16.5374 11.6574 16.5374 10.9992 16.3878L8.44818 19.449C10.6882 20.517 13.3118 20.517 15.5518 19.449ZM4.55102 15.5518L7.6122 13.0008C7.4626 12.3426 7.4626 11.6574 7.6122 10.9992L4.55102 8.44818C3.48299 10.6882 3.48299 13.3118 4.55102 15.5518ZM8.44818 4.55102L10.9992 7.6122C11.6574 7.4626 12.3426 7.4626 13.0008 7.6122L15.5518 4.55102C13.3118 3.48299 10.6882 3.48299 8.44818 4.55102ZM17.1055 3.6912C17.7424 4.08325 18.3435 4.55493 18.8943 5.10571C19.4451 5.65649 19.9167 6.25755 20.3088 6.89448C22.2304 10.0163 22.2304 13.9837 20.3088 17.1055C19.9167 17.7424 19.4451 18.3435 18.8943 18.8943C18.3435 19.4451 17.7424 19.9167 17.1055 20.3088C13.9837 22.2304 10.0163 22.2304 6.89448 20.3088C6.25755 19.9167 5.65649 19.4451 5.10571 18.8943C4.55493 18.3435 4.08325 17.7424 3.6912 17.1055C1.7696 13.9837 1.7696 10.0163 3.6912 6.89448C4.08325 6.25755 4.55493 5.65649 5.10571 5.10571C5.65649 4.55493 6.25755 4.08325 6.89448 3.6912C10.0163 1.7696 13.9837 1.7696 17.1055 3.6912ZM14.1213 9.87868C13.7958 9.55313 13.4158 9.31907 13.0115 9.17471C12.359 8.94176 11.641 8.94176 10.9885 9.17471C10.5842 9.31907 10.2042 9.55313 9.87868 9.87868C9.55313 10.2042 9.31907 10.5842 9.17471 10.9885C8.94176 11.641 8.94176 12.359 9.17471 13.0115C9.31907 13.4158 9.55313 13.7958 9.87868 14.1213C10.2042 14.4469 10.5842 14.6809 10.9885 14.8253C11.641 15.0582 12.359 15.0582 13.0115 14.8253C13.4158 14.6809 13.7958 14.4469 14.1213 14.1213C14.4469 13.7958 14.6809 13.4158 14.8253 13.0115C15.0582 12.359 15.0582 11.641 14.8253 10.9885C14.6809 10.5842 14.4469 10.2042 14.1213 9.87868Z" fill="currentColor"/>
      </svg>
      <h1 class="page-title__text">Support</h1>
    </div>
    <p class="page-title__sub">Find answers, browse documentation, or get in touch.</p>
  </div>

  <!-- Search -->
  <div class="support-search-card">
    <div class="support-search-card__header">
      <p class="support-search-card__title">How can we help you?</p>
      <p class="support-search-card__sub">Search our documentation and help articles.</p>
    </div>
    <div class="search-input-wrap">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.96544 11.0261C9.13578 11.6382 8.11014 12 7 12C4.23858 12 2 9.76142 2 7C2 4.23858 4.23858 2 7 2C9.76142 2 12 4.23858 12 7C12 8.11014 11.6382 9.13578 11.0261 9.96544L13.7803 12.7197C14.0732 13.0126 14.0732 13.4874 13.7803 13.7803C13.4874 14.0732 13.0126 14.0732 12.7197 13.7803L9.96544 11.0261ZM10.5 7C10.5 8.933 8.933 10.5 7 10.5C5.067 10.5 3.5 8.933 3.5 7C3.5 5.067 5.067 3.5 7 3.5C8.933 3.5 10.5 5.067 10.5 7Z" fill="#667599"/>
      </svg>
      <input type="text" placeholder="Search for anything..." />
    </div>
  </div>

  <!-- Popular topics -->
  <div class="support-topics-section">
    <p class="support-topics-label">Popular topics</p>
    <div class="support-topics">
      <div class="topic-card">
        <p class="topic-card__title">Getting Started</p>
        <p class="topic-card__desc">Set up your API key and make your first request</p>
        <a href="#" class="topic-card__link">Read guide →</a>
      </div>
      <div class="topic-card">
        <p class="topic-card__title">API Reference</p>
        <p class="topic-card__desc">Complete documentation for all endpoints and parameters</p>
        <a href="#" class="topic-card__link">Browse docs →</a>
      </div>
      <div class="topic-card">
        <p class="topic-card__title">Rate Limits</p>
        <p class="topic-card__desc">Understand usage limits and how to handle throttling</p>
        <a href="#" class="topic-card__link">Learn more →</a>
      </div>
    </div>
  </div>

  <!-- FAQ -->
  <div class="support-inner-card">
    <div class="support-inner-card__header">
      <p class="support-inner-card__title">Frequently Asked Questions</p>
    </div>
    <div class="faq-row">
      <span class="faq-row__q">How do I get an API key?</span>
      <span class="faq-row__a">Go to Management → API Keys and click + Create new key.</span>
    </div>
    <div class="faq-row">
      <span class="faq-row__q">What are the rate limits?</span>
      <span class="faq-row__a">Free plan: 100 req/day. Pro: 10,000 req/day. Enterprise: unlimited.</span>
    </div>
    <div class="faq-row">
      <span class="faq-row__q">How is billing calculated?</span>
      <span class="faq-row__a">You are charged per API call. View the pricing page for details.</span>
    </div>
    <div class="faq-row">
      <span class="faq-row__q">Can I use mila in production?</span>
      <span class="faq-row__a">Yes, use your Production API key and keep it secret.</span>
    </div>
  </div>

  <!-- Contact -->
  <div class="support-inner-card">
    <div class="support-inner-card__header">
      <p class="support-inner-card__title">Contact Support</p>
      <p class="support-inner-card__sub">Can't find your answer? Send us a message and we'll respond within 24 hours.</p>
    </div>
    <div class="contact-form">
      <div class="contact-fields">
        <div class="form-field">
          <label class="form-field__label">Name</label>
          <input type="text" class="field-input field-input--text" placeholder="Your name" />
        </div>
        <div class="form-field">
          <label class="form-field__label">Email</label>
          <input type="email" class="field-input field-input--text" placeholder="your@email.com" />
        </div>
      </div>
      <div class="form-field">
        <label class="form-field__label">Message</label>
        <textarea class="field-textarea" placeholder="Describe your issue..."></textarea>
      </div>
      <div>
        <button class="btn--primary">Send message</button>
      </div>
    </div>
  </div>

</div>
